

















import { handleError } from "@/lib/utility/handleError";
import { FleetManagerModule } from "@/store/modules/fleet/manager-fleet.store";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class FleetManagerTree extends Vue {
  @Prop({ required: true }) partnerId!: string;
  @Prop({ default: () => [] }) value!: string[];

  loading = false;
  openNodes: string[] = [];

  get selectedFleetIds() {
    return this.value || [];
  }

  set selectedFleetIds(selected: string[]) {
    this.$emit("input", selected);
    this.$emit("selection-changed", selected);
  }

  get fleetTree() {
    return FleetManagerModule.fleetTree;
  }

  get fleetId() {
    const fleetId = FleetManagerModule.selectedFleetId;

    if (fleetId) {
      return fleetId;
    }

    return UserModule.fleetPermission?.filter(p => p.partnerId === this.partnerId && p.fleetId)?.[0]?.fleetId;
  }

  async mounted() {
    await this.load(this.fleetId);
  }

  @Watch("fleetId")
  async onFleetIdChanged(newFleetId: string) {
    if (newFleetId) {
      await this.load(newFleetId);
    }
  }

  async load(fleetId: string) {
    this.loading = true;

    try {
      await FleetManagerModule.getFleetTree({ partnerId: this.partnerId, fleetId: fleetId });
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }

    this.updateOpenNodes();
  }

  getParentIds(tree: Array<{ id: string; children?: any[] }>, nodeId: string, path: string[] = []): string[] | null {
    for (const node of tree) {
      if (node.id === nodeId) {
        return path;
      }
      if (!node.children?.length) {
        continue;
      }
      const result = this.getParentIds(node.children, nodeId, [...path, node.id]);
      if (result) return result;
    }
    return null;
  }

  updateOpenNodes() {
    const openSet = new Set<string>();
    for (const id of this.selectedFleetIds) {
      // Only add parent nodes, not the selected node itself
      const parents = this.getParentIds(this.fleetTree, id);
      if (parents) {
        parents.forEach(pid => openSet.add(pid));
      }
    }
    this.openNodes = Array.from(openSet);
  }
}
